import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Text } from "../Text";
import { TextColors, TextTypes } from "../constants";

import "./styles.scss";

export const SingleQuestionAnswerText = ({
  answerClassName,
  answers,
  className,
  questionSetCategory,
  style,
}) => {
  const classNamesArray = ["apti-CL apti-SingleQuestionAnswerText", className];

  function getFormattedAnswers(answers) {
    return (
      <Text
        className={createClassNameString([
          "apti-SingleQuestionAnswerText--answer",
          answerClassName,
        ])}
      >
        {answers.length > 0 && answers.join(", ")}
      </Text>
    );
  }

  return (
    <div className={createClassNameString(classNamesArray)} style={style}>
      <div className="pb-3">
        <Text color={TextColors.purple} type={TextTypes.label}>
          {questionSetCategory}
        </Text>
      </div>

      {Array.isArray(answers) && getFormattedAnswers(answers)}

      {!Array.isArray(answers) && (
        <div className="apti-SingleQuestionAnswerTextSubCategory--text_wrapper">
          {Object.entries(answers).map(([subcategory, answers]) => {
            return (
              <div key={`apti-SingleQuestionAnswerTextSubCategory-${subcategory}`}>
                <div>
                  <Text type={TextTypes.label}>{subcategory}</Text>
                </div>
                {Array.isArray(answers) && getFormattedAnswers(answers)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

SingleQuestionAnswerText.propTypes = {
  answers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  questionSetCategory: PropTypes.string,
  style: PropTypes.object,
};

SingleQuestionAnswerText.defaultProps = {
  answers: {},
  className: undefined,
  questionSetCategory: undefined,
  style: {},
};
